import React, { useEffect, useMemo, useState, useCallback } from "react";
import "../../src/screens/Home/HomeUpdated/myPost.css";
import YouTubeService from "../api/YouTubeService";


const extractVideoId = (url) => {
  if (!url) return null;
  const match = url.match(
    /(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|watch\?feature=player_embedded&v=|watch\?v%3D|watch\?feature=player_embedded&v%3D|embed\/videoseries\?list=))(.*?)(?:\?|&|\/|$)/
  );
  return match ? match[1] : null;
};

const YoutubeVideoModel = ({ youtubeId }) => {
  const [videoDetails, setVideoDetails] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const videoId = useMemo(() => extractVideoId(youtubeId), [youtubeId]);

  useEffect(() => {
    if (!videoId) {
      setVideoDetails([]);
      return;
    }

    let isMounted = true;
    setLoading(true);
    setError(null);

    YouTubeService.getVideoDetails(videoId)
      .then((response) => {
        if (!isMounted) return;
        setVideoDetails(response.data?.items || []);
      })
      .catch((err) => {
        if (!isMounted) return;
        console.error("Error fetching video details:", err);
        setError("Unable to load video details");
      })
      .finally(() => {
        if (isMounted) setLoading(false);
      });

    return () => {
      isMounted = false;
    };
  }, [videoId]);

  const getDescription = useCallback((paragraph) => {
    if (!paragraph) return "";
    const maxWords = 70;
    const words = paragraph.split(" ");
    if (words.length <= maxWords) return paragraph;
    return words.slice(0, maxWords).join(" ") + "...";
  }, []);

  return (
    <div className="youtube-container">
      <div>
        {loading && <p className="text-secondary">Loading...</p>}
        {error && <p className="text-danger">{error}</p>}
        {videoDetails.map((video) => (
          <div key={video?.id}>
            <h5>{video?.snippet?.title}</h5>
            <p style={{ fontSize: "12px" }} className="text-secondary">
              {getDescription(video?.snippet?.description)}
            </p>
          </div>
        ))}
      </div>

      <div
        style={{ marginBottom: "-1.7rem", borderRadius: "5px" }}
        className="d-flex align-items-center justify-content-center position-relative p-2"
      >
        <iframe
          width="765"
          height="390"
          src={youtubeId ? `${youtubeId}?showinfo=0&rel=0` : ""}
          title="YouTube Video Player"
          frameBorder="0"
          allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        />
      </div>
    </div>
  );
};

YoutubeVideoModel.defaultProps = {
  youtubeId: "",
};

export default React.memo(YoutubeVideoModel);